import { mockGetApiPath } from './mock-api-get-path';
let apiPath = '';
export function getApiPath(fromMock = false) {
    if (fromMock) {
        return mockGetApiPath();
    }
    return apiPath;
}
export function setApiPath(path) {
    apiPath = path;
}
